import _ from 'lodash';

export function toSnakeCaseKeys(obj) {
  if (_.isArray(obj)) {
    return obj.map(toSnakeCaseKeys);
  } else if (_.isObject(obj) && !_.isDate(obj)) {
    return _.reduce(obj, (result, value, key) => {
      const newKey = _.snakeCase(key);
      result[newKey] = toSnakeCaseKeys(value);
      return result;
    }, {});
  }
  return obj;
}